export default __webpack_public_path__ + "static/media/TwilightZone.7c8b1f26.mp3";